<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon
      :disabled="!this.enableDocumentItemEdit()">
        <v-icon :color="ui.btnColor"> create </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            Edit Role
            <v-spacer/>
            {{displayDocumentIDGTypeA("G4", role.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row class="mr-2">
                <v-flex xs12 sm10>
                  <v-text-field
                    v-model="localFormEdit.title"
                    label="role title"
                    :rules="mustBeLessThanSmall"
                    prepend-icon="title"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="role.char.person ===  'Required'">
                <div v-if="role.user.udid ===  ''">
                  <v-avatar>
                    <v-icon :color="ui.colorWarning">warning</v-icon>
                  </v-avatar>
                  <v-chip :color="ui.chipColor" :text-color="ui.colorWarning" class="subheading">
                    No User Assigned
                  </v-chip>
                </div>
                <div v-else>
                  <v-avatar>
                    <v-icon :color="ui.btnColor">
                      {{role.char.icon}}
                    </v-icon>
                  </v-avatar>
                  <v-chip :color="ui.chipColor" :text-color="ui.textColor" class="subheading">
                    {{role.user.uname}}, {{role.user.uemail}}
                  </v-chip>
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm5>
                  <v-select
                    v-model="localFormEdit.type"
                    :items="roleType"
                    :label="localFormEdit.type"
                    prepend-icon="person"
                    hint="role"
                    persistent-hint
                    required
                    :readonly="getDetail.basic.tag === 'B3'"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    v-model="localFormEdit.ref"
                    :rules="ruleMustBeNotUndefinedANDLessThan25"
                    label="reference"
                    hint="ref"
                    persistent-hint
                    prepend-icon="bookmark"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm5>
                  <v-select
                    v-model="localFormEdit.person"
                    :items="roleAssign"
                    :label="localFormEdit.person"
                    prepend-icon="group_add"
                    hint="assignee"
                    persistent-hint
                    required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-select
                    v-model="localFormEdit.crit"
                    :items="roleCriticality"
                    :label="localFormEdit.crit"
                    prepend-icon="priority_high"
                    hint="business imp"
                    persistent-hint
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm10>
                  <v-select
                    v-model="localFormEdit.theme"
                    :items="roleTheme"
                    :label="localFormEdit.theme"
                    prepend-icon="grid_view"
                    hint="position"
                    persistent-hint
                    required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm10>
                  <v-text-field
                    v-model="localFormEdit.obj"
                    label="role objective"
                    :rules="mustBeLessThanLarge"
                    prepend-icon="account_box"
                    hint="role objective"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-0">
                <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
                  Role and Responsibilities Description
                </v-chip>
              </v-layout>
              <InfoDateAgoName :data="this.role.stats"/>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localFormEdit.resp"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="role description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn class="hidden-xs-only"
            @click="closeDialog()" :color="ui.btnColor" flat>
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn class="hidden-sm-and-up"
            @click="closeDialog()" :color="ui.btnColor" flat>
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="deleteRole()" color="error" flat
            class="hidden-xs-only"
            v-if="this.getDetail.basic.tag !== 'B3'">
              <v-icon left> delete </v-icon>
                Delete
            </v-btn>
            <v-btn @click="deleteRole()" color="error" flat
            class="hidden-sm-and-up"
            v-if="this.getDetail.basic.tag !== 'B3'">
              <v-icon> delete </v-icon>
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import roleOptions from "@/data/options/mixins/roleOptions.js";
import roleFunctions from "@/data/functions/mixins/roleFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import moment from "moment";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";

export default {
  // eslint-disable-next-line
  components: {
    InfoDateAgoName
  },
  mixins: [
    numberFunctions,
    master,
    roleOptions,
    roleFunctions,
    rulesTextfield,
    dateFunctions,
    apptheme,
    docRevsModFunctions,
    displayFunctions,
    documentFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getRolesList",
      "getUser",
      "getRolesListCounter",
      "getDetail"
    ]),
    textTitle() {
      let k = "title";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    }
  },
  props: {
    role: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localFormEdit: {
        title: "",
        type: "",
        theme: "",
        obj: "",
        ref: "",
        resp: "",
        perosn: "",
        cri: ""
      }
    };
  },
  beforeMount() {
    this.localFormEdit.title = this.role.basic.title;
    this.localFormEdit.type = this.role.char.type;
    this.localFormEdit.theme = this.role.char.theme;
    this.localFormEdit.ref = this.role.char.ref;
    this.localFormEdit.obj = this.role.char.obj;
    this.localFormEdit.resp = this.role.char.resp;
    this.localFormEdit.person = this.role.char.person;
    this.localFormEdit.crit = this.role.char.crit;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    deleteRole() {
      let newList = [];
      let oldList = this.getRolesList;
      let idi = this.role.basic.idi;
      // loop
      for (var i = 0; i < oldList.length; i++) {
        // eslint-disable-next-line
        if (idi !== oldList[i].basic.idi) {
          // newID = newID + 1;
          // list[i].basic.id = newID;
          // LOGIC TEST
          console.log(idi);
          console.log(oldList[i].basic.idi);
          console.log(newList);
          newList.push(oldList[i]);
        }
      }
      this.$store.dispatch("changeRolesList", newList);
      // eslint-disable-next-line
      this.$store.dispatch("changeRolesListCounter", this.getRolesListCounter + 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(4.32); // Role removed.
      // HELP
      // console.log("RoleEdit");
      // console.log("deleteRole");
      // console.log(newList);
      // Close dialog
      this.dialog = false;
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.role;
        // change form
        tempForm.basic.title = this.localFormEdit.title;
        tempForm.char.obj = this.localFormEdit.obj;
        tempForm.char.ref = this.localFormEdit.ref;
        tempForm.char.resp = this.localFormEdit.resp;
        tempForm.char.type = this.localFormEdit.type;
        tempForm.char.theme = this.localFormEdit.theme;
        tempForm.char.crit = this.localFormEdit.crit;
        tempForm.char.person = this.localFormEdit.person;

        // add icon
        tempForm.char.icon = this.selectIconFromRole(tempForm.char.type);

        // Ovewrite name / date
        tempForm.stats.date = moment().format();
        // eslint-disable-next-line
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // current task list
        // console.log(this.getRolesList);
        var tempRoleList = this.getRolesList;
        tempRoleList[this.role.basic.id - 1] = this.tempForm;
        // console.log(tempRoleList);
        // Submit to store
        this.$store.dispatch("changeRolesList", tempRoleList);
        this.saveDocumentRevMod(4.33); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // HELP
        console.log("RoleEdit");
        // console.log("validate");
        console.log(tempForm);
        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
